function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import Modal from 'react-modal';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { trackEvent } from 'rubriq/helpers/mixpanel';
import { createDigitalOrder } from 'researcher/digital-orders/actions';
import { TYPE_TRANSLATION } from 'researcher/digital-orders/constants';
import Files, { endpoints } from 'shared/helper/file';
import FileRubriq from 'shared/helper/file/components/FileRubriq';
import { FILE_STATUS } from 'shared/helper/file/constants';
import { Controls, useFormHelpers, validators } from 'shared/helper/form';
import { T, useTranslate } from 'shared/helper/translate';
import { convertFormDataToDigitalOrderUpdateRequest } from 'shared/view/digital-order-conversion-service';
import featureEnabled from 'shared/helper/feature';
import { syncUser } from '../actions';
import { getTranslationStatus, getTranslationsRenewalDate } from '../reducer';
import RubriqUploadButton from './RubriqUploadButton';
var defaultValues = {
  digitalTranslationFiles: [],
  language: '',
  type: TYPE_TRANSLATION
};
var fileType = 'digitalTranslation';
var Errors = Controls.Errors,
  Form = Controls.Form,
  Radio = Controls.Radio;
var notEmpty = validators.notEmpty;
var TranslateDocumentModal = function TranslateDocumentModal(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    submitting = _useState2[0],
    setSubmitting = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    dragActive = _useState4[0],
    setDragActive = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    currentPageIndex = _useState6[0],
    setCurrentPageIndex = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showError = _useState8[0],
    setShowError = _useState8[1];
  var methods = useForm({
    defaultValues: defaultValues,
    shouldFocusError: false
  });
  var _methods$watch = methods.watch(['digitalTranslationFiles', 'language']),
    _methods$watch2 = _slicedToArray(_methods$watch, 2),
    digitalTranslationFiles = _methods$watch2[0],
    language = _methods$watch2[1];
  var hasFile = digitalTranslationFiles && digitalTranslationFiles.length > 0;
  var _useFormHelpers = useFormHelpers(),
    preprocessData = _useFormHelpers.preprocessData;
  var dispatch = useDispatch();
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    curie = _useSelector.curie;
  var _getTranslationStatus = getTranslationStatus({
      curie: curie
    }),
    premiumTranslationsRemaining = _getTranslationStatus.premiumTranslationsRemaining,
    groupTranslationsRemaining = _getTranslationStatus.groupTranslationsRemaining;
  var deepSeekEnabled = featureEnabled('rubriq_china_deep_seek');
  var renewalDate = getTranslationsRenewalDate({
    curie: curie
  }, t);
  var wordCountAttempts = 0;
  var disableButtonForUnlimited = submitting || deepSeekEnabled && premiumTranslationsRemaining === 0 && groupTranslationsRemaining === 0 && language !== 'zh_CN';
  var screens = [{
    title: /*#__PURE__*/React.createElement(T, {
      source: "upload-document"
    }),
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "".concat(digitalTranslationFiles.length === 0 ? 'submit-digital-translation-form p-3 py-5 mt-2' : '', " ").concat(dragActive ? 'hovered' : ''),
      style: {
        backgroundColor: digitalTranslationFiles.length === 0 ? '#FAFAFA' : ''
      }
    }, /*#__PURE__*/React.createElement(Files, {
      apiRoot: endpoints.researcher,
      maxUploads: 1,
      methods: methods,
      name: "digitalTranslationFiles",
      type: fileType,
      disabled: submitting,
      fileRenderer: FileRubriq,
      required: true,
      fileUploadButton: function fileUploadButton(_ref2) {
        var onClick = _ref2.onClick,
          isDragActive = _ref2.isDragActive,
          disabled = _ref2.disabled;
        return /*#__PURE__*/React.createElement(RubriqUploadButton, {
          onClick: onClick,
          isDragActive: isDragActive,
          disabled: disabled,
          onDragStatusChanged: function onDragStatusChanged(active) {
            return setDragActive(active);
          },
          hasFile: hasFile
        });
      }
    }), digitalTranslationFiles.length === 0 && /*#__PURE__*/React.createElement("label", {
      className: "control-label text-secondary text-transform-none text-center w-100 me-3 ms-e"
    }, /*#__PURE__*/React.createElement(T, {
      source: "curie-file-upload-requirements",
      params: {
        wordLimit: '12,000'
      }
    }))), showError && /*#__PURE__*/React.createElement("div", {
      className: "text-danger mt-3"
    }, /*#__PURE__*/React.createElement(T, {
      source: "file-upload-error"
    }))),
    isValid: function isValid() {
      return hasFile && digitalTranslationFiles.every(function (file) {
        return file.status === FILE_STATUS.STATUS_UPLOAD_SUCCESS;
      });
    }
  }, {
    title: /*#__PURE__*/React.createElement(T, {
      source: "language-preference"
    }),
    content: /*#__PURE__*/React.createElement("div", {
      className: "d-flex flex-column justify-content-between h-100"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "fw-semibold mb-3",
      htmlFor: "styleOfEnglish",
      style: {
        fontSize: '1rem'
      }
    }, /*#__PURE__*/React.createElement(T, {
      source: "starting-language-label"
    })), /*#__PURE__*/React.createElement(Radio, {
      name: "language",
      validators: {
        notEmpty: notEmpty
      },
      styles: {
        label: 'text-secondary text-transform-none',
        formCheck: 'mb-3',
        wrapper: 'rubriq-control-group pb-0'
      },
      options: [{
        value: 'zh_CN',
        term: /*#__PURE__*/React.createElement(T, {
          source: "zh_CN"
        }),
        label: /*#__PURE__*/React.createElement(T, {
          source: "zh_CN"
        })
      }, {
        value: 'es_ES',
        term: /*#__PURE__*/React.createElement(T, {
          source: "es_ES"
        }),
        label: /*#__PURE__*/React.createElement(T, {
          source: "es_ES"
        })
      }, {
        value: 'pt_BR',
        term: /*#__PURE__*/React.createElement(T, {
          source: "pt_BR"
        }),
        label: /*#__PURE__*/React.createElement(T, {
          source: "pt_BR"
        })
      }]
    }), /*#__PURE__*/React.createElement(Errors, {
      name: "language",
      messages: {
        notEmpty: 'curie.digital-translation-language-empty-error'
      },
      wrapper: "p",
      styles: {
        error: 'error mb-4'
      }
    })), /*#__PURE__*/React.createElement("div", null, (language === 'es_ES' || language === 'pt_BR') && /*#__PURE__*/React.createElement(React.Fragment, null, premiumTranslationsRemaining > 0 || groupTranslationsRemaining > 0 ? /*#__PURE__*/React.createElement("div", {
      className: "fw-semibold fs-6 mb-3 text-center"
    }, /*#__PURE__*/React.createElement(T, {
      source: "curie-translation-warning"
    })) : /*#__PURE__*/React.createElement("div", {
      className: "translation-warning rounded-3 p-3 position-relative mb-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "warning-icon position-absolute top-0 start-0 translate-middle-x mt-3 ms-3"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-light fa-circle-exclamation",
      className: "fs-5"
    })), /*#__PURE__*/React.createElement("div", {
      className: "ms-4"
    }, /*#__PURE__*/React.createElement(T, {
      source: "number-of-premium-translations-exceeded-content",
      params: {
        renewalDate: renewalDate
      }
    })))))),
    isValid: function isValid() {
      return false;
    }
  }];
  var close = function close(result) {
    var errorId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    setSubmitting(false);
    methods.reset(defaultValues);
    setCurrentPageIndex(0);
    setShowError(false);
    wordCountAttempts = 0;
    onClose(result, errorId);
  };
  var handleClickNext = function handleClickNext() {
    if (screens[currentPageIndex].isValid()) {
      if (currentPageIndex === 0 && digitalTranslationFiles.length > 0) {
        var _file$name, _file$identity;
        var file = digitalTranslationFiles[0];
        trackEvent('Translation Document Uploaded', {
          file_type: file.type,
          file_name: (_file$name = file.name) !== null && _file$name !== void 0 ? _file$name : null,
          file_identity: (_file$identity = file.identity) !== null && _file$identity !== void 0 ? _file$identity : null,
          language: language
        });
      }
      setShowError(false);
      if (currentPageIndex < screens.length - 1) {
        setCurrentPageIndex(currentPageIndex + 1);
      }
    } else {
      setShowError(true);
    }
  };
  var handleSubmit = function handleSubmit() {
    var _file$name2, _file$identity2;
    var file = digitalTranslationFiles[0];
    trackEvent('Translation Started', {
      file_type: file.type,
      file_name: (_file$name2 = file.name) !== null && _file$name2 !== void 0 ? _file$name2 : null,
      file_identity: (_file$identity2 = file.identity) !== null && _file$identity2 !== void 0 ? _file$identity2 : null,
      language: language
    });
    methods.handleSubmit(preprocessData(convertFormDataToDigitalOrderUpdateRequest, _submitDigitalTranslation))();
  };
  var _submitDigitalTranslation = function submitDigitalTranslation(data) {
    setSubmitting(true);
    dispatch(createDigitalOrder(data, false, false)).then(function (res) {
      var digitalOrderError = res.error;
      if (digitalOrderError) {
        var errorId = digitalOrderError.error;
        if (errorId === 'word-count-not-received') {
          if (wordCountAttempts < 12) {
            setTimeout(_submitDigitalTranslation(data), 5000);
            wordCountAttempts += 1;
            return;
          }
        }
        close(false, errorId);
      } else {
        // make sure the number of translations used is updated
        dispatch(syncUser()).then(function () {
          close(true);
        });
      }
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, open && /*#__PURE__*/React.createElement(Modal, {
    appElement: document.querySelector('#researcher-app'),
    isOpen: true,
    overlayClassName: "react-modal-overlay",
    className: "react-modal"
  }, /*#__PURE__*/React.createElement("div", {
    className: "react-modal-header"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-close",
    onClick: function onClick() {
      return close(false);
    },
    "aria-label": t('close')
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/React.createElement("h1", {
    className: "react-modal-title"
  }, screens[currentPageIndex].title)), /*#__PURE__*/React.createElement(Form, {
    methods: methods,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: "react-modal-content",
    style: {
      height: 317
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "digital-translations h-100"
  }, screens[currentPageIndex].content)), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-footer"
  }, currentPageIndex === screens.length - 1 ? /*#__PURE__*/React.createElement("button", {
    type: "submit",
    disabled: disableButtonForUnlimited,
    className: "btn btn-primary btn-squared me-3",
    key: "start"
  }, /*#__PURE__*/React.createElement(T, {
    source: "start"
  }), submitting ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-1",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : null) : /*#__PURE__*/React.createElement("button", {
    "aria-label": t('continue'),
    type: "button",
    onClick: handleClickNext,
    className: "btn btn-primary btn-squared me-3",
    key: "continue"
  }, /*#__PURE__*/React.createElement(T, {
    source: "continue"
  })), /*#__PURE__*/React.createElement("button", {
    "aria-label": t('cancel'),
    type: "button",
    onClick: function onClick() {
      return close(false);
    },
    className: "btn btn-secondary btn-squared"
  }, /*#__PURE__*/React.createElement(T, {
    source: "cancel"
  }))))));
};
export default TranslateDocumentModal;